/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default function PromosLinks({ levelIdx, promos, onLeafItemMouseOver, onPromoLinkClick }) {
  return promos.map((promo, idx) => (
    <li key={`${promo.name}${idx}`} className={`level-item highlight ${promo.type} leaf`}>
      <Link
        className="level-item-link"
        to={promo.link}
        onFocus={onLeafItemMouseOver}
        onMouseOver={onLeafItemMouseOver}
        onClick={onPromoLinkClick(promo.name, levelIdx)}
      >
        {promo.name}
      </Link>
    </li>
  ));
}

PromosLinks.propTypes = {
  levelIdx: PropTypes.any,
  promos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onLeafItemMouseOver: PropTypes.func.isRequired,
  onPromoLinkClick: PropTypes.func.isRequired,
};
